import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ApiserviceService } from '../../../../src/app/apiservice.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-admin-api-log-setting',
  templateUrl: './admin-api-log-setting.component.html',
  styleUrls: ['./admin-api-log-setting.component.css']
})
export class AdminApiLogSettingComponent {
 @Output() switchToLogService = new EventEmitter<boolean>();
  @Input() selectedLogType: string;
  limit: number = 10;
  offset: number = 0;
  dataSource: any = [];
  totalCount: number;
  displayedColumns = [
    // 'checkbox',
    // 'SN',
    'id',
    'log_type',
    'description',
  'active_status']
  pageSizeOptions: number[] = [5, 10, 25, 50]
  pageEvent: PageEvent;
  selectedService: string = 'ges';
  loader: boolean = false;

  constructor(
    private readonly api: ApiserviceService
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.getLogServiceDetails(this.selectedLogType);
    this.changeApiSerivice()
  }
    ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedLogType'] && !changes['selectedLogType'].firstChange) {
      this.changeApiSerivice();
    }
  }
onPageChange(event: any) {
  this.limit = event.limit; // Update limit based on pagination event
  this.offset = event.offset; // Update offset based on pagination event
  // this.getAttributes();
}
logServicePage() {
  this.switchToLogService.emit(false);
}
  //get api data
  getLogServiceDetails(service: string) {
    // if (!this.log_setting_access.GET) {
    //   this.notify.notify("User not Authorized to Get Log Setting Data", "warn");
    //   return;
    // }

    const url = "api-log-settings";

    const serviceApiMap: { [key: string]: (url: string) => Observable<any> } = {
      ges: this.api.getGesData.bind(this.api),
      gms: this.api.getGmsData.bind(this.api),
      gmus: this.api.getGmusData.bind(this.api),
      gps: this.api.getGpsData.bind(this.api),
      Ums: this.api.getUmsData.bind(this.api),
      GIS_service: this.api.getGisServiceData.bind(this.api),
    };

    const apiCall = serviceApiMap[service];
    this.loader = true;
    apiCall(url).subscribe({
      next: (response: any) => {
        this.dataSource = response.data;
        this.loader = false;
      },
      error: (error) => {
         this.loader = false;
         this.dataSource = []
      },
    });
  }

  updateApiLogStatus(event: { logType: string; status: number; source?: any }) {
    // if (!this.log_setting_access.PATCH) {
    //   this.notify.notify(
    //     "User not Authorized to Update API Log Setting Status",
    //     "warn"
    //   );
    //   event.source.checked = !event.source.checked;
    //   return;
    // }

    const { logType, status } = event;
    const url = `api-log-settings?log_type=${logType}&status=${status}`;

    const serviceApiMap: { [key: string]: (url: string,  body: any) => Observable<any>,  } = {
      ges: this.api.patchGesData.bind(this.api),
      gms: this.api.patchGmsData.bind(this.api),
      gmus: this.api.patchGmusData.bind(this.api),
      gps: this.api.patchGpsData.bind(this.api),
      Ums: this.api.patchUmsData.bind(this.api),
      GIS_service: this.api.patchGisServiceData.bind(this.api),
    };

    const apiCall = serviceApiMap[this.selectedLogType];
   this.loader = true;
    apiCall(url, {}).subscribe({
      next: (response: any) => {
        // this.notify.notify(response.message, "success");
        this.loader = false;
        this.getLogServiceDetails(this.selectedLogType);
      },
      error: (error) => {
         this.loader = false;
      },
    });
  }
  changeApiSerivice(){
    this.getLogServiceDetails(this.selectedLogType);
    console.log("working fine");
  }
}
